import { selectTripEndDate, selectTripStartDate } from "store/quote/selectors";
import { useSelector } from "hooks/use-selector";
import {
  MAX_LIMITED_TRIP_LENGTH_DURATION_DAYS,
  LIMITED_TRIP_LENGTH_STATES,
} from "settings";
import dayjs from "dayjs";

export function useLimitedTripLengthIsValid() {
  const tripStartDate = useSelector(selectTripStartDate);
  const tripEndDate = useSelector(selectTripEndDate);
  // const tripLength = useSelector(selectTripDays);
  // TODO: Remove this when the backend is updated to return tripDays correctly | assigned to DEV-10448
  const tripLengthTemp =
    dayjs(tripEndDate).diff(dayjs(tripStartDate), "day") + 1;

  if (!tripStartDate) {
    throw new Error("tripStartDate is empty.");
  } else if (!tripEndDate) {
    throw new Error("tripEndDate is empty.");
  }

  return (stateCode: string) => {
    if (!LIMITED_TRIP_LENGTH_STATES.includes(stateCode)) {
      return true;
    }

    return Boolean(
      tripLengthTemp && tripLengthTemp <= MAX_LIMITED_TRIP_LENGTH_DURATION_DAYS,
    );
  };
}
